module.exports = __webpack_public_path__ + "img/delete.76ba25a2.png";